import React from "react";
import { Box, Stack } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import { Card, Text, Title, PointsTitle } from "./termsAndPolicy.components";

function TermsAndPolicy({ title, intro, content, quote, type }) {
  return (
    <OuterWrapper sx={{ pt: "50px", pb: "100px", backgroundColor: "#F8FBFE" }}>
      <InnerWrapper>
        <Card
          sx={{
            mx: 1.25,
            px: { xs: "25px", md: "50px" },
            py: { xs: "50px", md: "100px" },
          }}
        >
          <Title>{title}</Title>
          {type === "terms" ? <DisplayTerms /> : <DisplayPolicy />}
        </Card>
      </InnerWrapper>
    </OuterWrapper>
  );

  function DisplayTerms() {
    return (
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
      >
        <Box>
          {content.map((data, point) => {
            return (
              <>
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={1}
                  mb={1}
                >
                  <PointsTitle>{point + 1}. </PointsTitle>
                  <PointsTitle>{data.title}</PointsTitle>
                </Stack>
                <Text mb={3}>{data.description}</Text>
              </>
            );
          })}
        </Box>
        <Text>{quote}</Text>
      </Stack>
    );
  }

  function DisplayPolicy() {
    return (
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2.5}
      >
        <Text>{intro}</Text>
        <Box>
          {content.map((data, point) => {
            return (
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                mb={3}
              >
                <Text>{point + 1}. </Text>
                <Text>{data}</Text>
              </Stack>
            );
          })}
        </Box>
        <Text>{quote}</Text>
      </Stack>
    );
  }
}

export default TermsAndPolicy;
